import React from 'react'
import { Grid } from "@mui/material";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { UiInputGroupWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from '../../../../../_uiComponents/telerikComponents/UiInput'
import Stack from '@mui/material/Stack';
import {
    UiButton,
} from "../../../../../_uiComponents/common/form/UiButton";
import GamePlayRewardPotConfiguration from './GamePlayRewardPotConfiguration';
import UiTopDropDownList from '../../../../../_uiComponents/telerikComponents/UiTopDropDownList';
import { UiRadioButton } from '../../../../../_uiComponents/telerikComponents/UiRadioButton';
import GameplayWheelConfigurationForm from './forms/GameplayWheelConfigurationForm';
import GameplayWinningSlotConfigurationForm from './forms/GameplayWinningSlotConfigurationForm';

export default function Rewards(props) {

    const options = [
        { value: "value-1", label: "text-1" },
        { value: "value-2", label: "text-2" },
        { value: "value-3", label: "text-3" },
    ];
    const data = [{
        label: 'Continuous Wining Game Play',
        value: '0'
    }, {
        label: ' Unlucky Game Play ',
        value: '1'
    }, {
        label: 'Shuffle Game Play ',
        value: '2'
    }];

    const areaValidator = value => value ? '' : 'Area is required.';

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 2, mb: 6 }}>
                <Grid item xs={12} lg="4">
                    <div className='sbm-rewards-top-box sbm-rewards-allocated-points'>
                        <h3>Total Points Budget</h3>
                        <span>2250</span>
                    </div>
                </Grid>
                <Grid item xs={12} lg="4">
                    <div className='sbm-rewards-top-box sbm-rewards-utilized-points'>
                        <h3>Total Issued Points</h3>
                        <span>1000</span>
                    </div>
                </Grid>
                <Grid item xs={12} lg="4">
                    <div className='sbm-rewards-top-box sbm-rewards-remaining-points'>
                        <h3>Total Unissued Points</h3>
                        <span>1250</span>
                    </div>
                </Grid>
            </Grid>
            
            <UiInputGroupWr
                title=" Game Play Token Configuration"
            >
                {/* <Form onSubmit={handleSubmit}
                render={formRenderProps =>
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid
                        item
                        xs={12}
                        lg={6}
                    >
                        <Field name={'requiredClaimTokenCount'}
                                    validator={areaValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'Required Claim Token Count'} />
                       
                    </Grid>
                    <Grid item xs={12} lg={12} sx={{ mb: 2 }} >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Save" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                </Grid>
            }
            /> */}
            </UiInputGroupWr>

            <GameplayWheelConfigurationForm/>
            <GameplayWinningSlotConfigurationForm/>

            <UiInputGroupWr
                title="Gameplay Wheel Configuration"
            >
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid
                        item
                        xs={12}
                        lg={6}
                    >
                        <UiInput
                            type="text"
                            label="Total Reward Slots"
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        lg={6}
                    >
                        <UiInput
                            type="text"
                            label="Total Unlucky Slots"
                        />
                    </Grid>
                    <Grid item xs={12} lg={12} sx={{ mb: 2 }} >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Save" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                </Grid>
            </UiInputGroupWr>

            <UiInputGroupWr
                title=" Game Play Winning Slot Configuration"
            >
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid
                        item
                        xs={12}
                        lg={12}
                    >
                        
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                            <UiRadioButton name="test"/>
        
                            Win After Every
       
                            <UiInput
                            type="text"
                            
                        />
                        Unlucky Game Play
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center' }}>
                            <UiRadioButton name="test"/>
        
                            Win After Everys
       
                            <UiInput
                            type="text"
                            
                        />
                        Unlucky Game Play
                    </label>
                    
      
                       
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        lg={4}
                    >
                       
                        <UiInput
                            type="text"
                            label="Win After Every"
                        />
                    </Grid>
                    <Grid item xs={12} lg={12} sx={{ mb: 2 }} >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Save" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                </Grid>
            </UiInputGroupWr>

            <UiInputGroupWr
                title="Game Play Reward Pot Configuration"
            >
                <Grid container spacing={2} sx={{ mb: 1 }} className='sba-btn-section-wr'>
                    <Grid
                        item
                        xs={12}
                        lg={4}
                    >
                        <UiTopDropDownList label="Reward Points" data={options} />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        lg={5}
                        sx={{ mt: 2.5 }}
                    >
                        <UiButton name="Add Point" variant="contained" size="small" />
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 1 }} className='sba-btn-section-wr'>
                    <Grid
                        item
                        xs={12}
                        lg={4}
                    >
                        <UiTopDropDownList label="Reward Vouchers" data={options} />
                    </Grid>
                    
                    <Grid
                        item
                        xs={12}
                        lg={5}
                        sx={{ mt: 2.5 }}
                    >
                        <UiButton name="Add Voucher" variant="contained" size="small" />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        lg={12}
                    >
                        <label className='sb-vouhcer-label'>Voucher Type : </label>                     
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        lg={12}
                    >                      
                        <label className='sb-vouhcer-label'>Voucher Value : </label>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid
                        item
                        xs={12}
                        lg={12}
                    >
                        <GamePlayRewardPotConfiguration />
                    </Grid>
                </Grid>
            </UiInputGroupWr>

        </>
    )
}
